import { Alert, Button, FormGroup, IconButton, TextField } from '@mui/material'

import { parse } from "mathjs";

import { useEffect, useState } from 'react'
import Latex from 'react-latex-next'
import { compareEquations } from '../../../selectors/Ecuaciones';
import { isEquation } from '../../../selectors/Ecuaciones/functions';
import Menu from './Menu';

// mui icons
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { EjercicioState } from '../../../store/slices/ejercicio';

type Props = {
    index: number
    ejercicio: EjercicioState
    handleEliminarEjercicio: Function
    handleEditarEjercicio: Function
}

type State = {
    ok: null | Boolean
    title: string
    msg: string
}

const FormularioEcuacionEdicion = ({ index, ejercicio, handleEliminarEjercicio, handleEditarEjercicio }: Props) => {

    const { tipo, enunciado, respuesta } = ejercicio;

    const [respuestaUsuario, setRespuestaUsuario] = useState('');

    const [toTex, setToTex] = useState('');
    const [error, setError] = useState(false);
    const [onFocus, setOnFocus] = useState(false);

    const [state, setState] = useState<State>({
        ok: null,
        title: '',
        msg: ''
    });

    const [alert, setAlert] = useState(false);

    useEffect(() => {
        if (alert) {
            const timer = setTimeout(() => { setAlert(false); }, 5000);
            return () => clearTimeout(timer);
        }
    }, [alert]);

    // PENDIENTE
    // useEffect(() => {
    //     if (state.ok !== null) {
    //         socket?.emit('actualizar-ejercicio', {eid: eid, estado: state.ok});
    //         dispatch(actualizarEjercicio(eid, state.ok))
    //     }
    // }, [state, eid, socket, dispatch])

    useEffect(() => {
        if (respuestaUsuario === '') {
            setToTex('');
            return setError(false);
        }

        const respuestaUsuarioClean = respuestaUsuario.replace(/ /g, '').replaceAll('x', 'X').replaceAll('y', 'Y');

        if (isEquation(respuestaUsuarioClean).ok) {
            try {
                const respuesta = respuestaUsuario.replace(/=/g, '==');
                const toTex = parse(respuesta).toTex()
                setToTex(`\\[${toTex}\\]`);
                setError(false);
            } catch (error) {
                setToTex(respuestaUsuario);
                setError(true);
            }
        } else {
            setToTex(respuestaUsuario);
            setError(true);
        }
    }, [respuestaUsuario]);

    const handleRespuesta = () => {
        if (respuestaUsuario !== '') {
            setAlert(true);
            setState(compareEquations(respuesta, respuestaUsuario));
        }
    }

    return (
        <div className='card mb-5'>
            <div className="card-header py-2">
                <div className="row justify-content-between align-items-center my-1">
                    <div className="col-auto">
                        Ejercicio {index + 1}
                    </div>
                    <div className="col-auto">
                        <IconButton
                            onClick={() => handleEditarEjercicio(ejercicio)}
                            size='small'
                        >
                            <EditIcon fontSize="inherit" />
                        </IconButton>

                        <IconButton
                            onClick={() => handleEliminarEjercicio(ejercicio)}
                            size='small'
                        >
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <Latex>{`${enunciado}`}</Latex>
            </div>
            <div className="card-footer">
                <div className="row justify-content-between align-items-center my-0">
                    <div className="col-auto">
                        <FormGroup sx={{ py: 1 }} row>
                            <TextField
                                // id="outlined-basic"
                                type='text'
                                sx={{ minWidth: 300 }}
                                label="Ingrese una ecuacion en las variable x e y"
                                variant="outlined"
                                size="small"
                                autoComplete='off'
                                value={respuestaUsuario}
                                onChange={(e) => setRespuestaUsuario(e.target.value)}
                                onFocus={() => setOnFocus(true)}
                                onBlur={() => setTimeout(() => setOnFocus(false), 2000)}
                            />
                            <Button
                                sx={{ mx: 1 }}
                                size="small"
                                color="primary"
                                variant="outlined"
                                onClick={handleRespuesta}
                                aria-label="close"
                                disabled={alert}
                            >
                                Revisar
                            </Button>
                        </FormGroup>
                    </div>
                    <div className="col-auto">
                        <Menu tipo={tipo} />
                    </div>
                    {
                        onFocus &&
                        <div className="col-12">
                            <div className="row justify-content-center align-items-center my-3">
                                <div className="col-11" style={{ backgroundColor: 'white', minHeight: '5em', border: 'solid #808080 1px', borderRadius: '5px' }}>
                                    <div style={{ color: error ? 'red' : '', backgroundColor: 'white' }} className="text-center p-1">
                                        <Latex>{toTex}</Latex>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div className="col-12">
                        {
                            alert &&
                            <Alert
                                severity={state.ok === null ? 'info' : (state.ok ? 'success' : 'error')}
                                sx={{ position: 'relative', mt: 1 }}
                            >
                                {state.title} {state.msg}
                            </Alert>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FormularioEcuacionEdicion;